module.exports = __webpack_public_path__ + "img/52.b5088216.jpg";